import React, { useEffect, useState } from "react";
import { Button, Alert, Badge } from "react-bootstrap";
import { getMyReferrals } from "../services/partnerAuthService";

const getErr = (err, fallback) => err.response?.data?.error || fallback;

export default function Referrals() {
  const [referralCode, setReferralCode] = useState("");
  const [referrals, setReferrals] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    getMyReferrals()
      .then(({ data }) => {
        setReferralCode(data.data?.referralCode || "");
        setReferrals(data.data?.referrals || []);
      })
      .catch((err) => setError(getErr(err, "Failed to load referrals")))
      .finally(() => setLoading(false));
  }, []);

  const copyCode = () => {
    navigator.clipboard?.writeText(referralCode);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  if (loading) return <p>Loading referrals…</p>;

  return (
    <div>
      <h4 className="mb-3">Partner Referrals</h4>
      {error && <Alert variant="danger">{error}</Alert>}

      <div className="partner-card mb-4">
        <h6 className="mb-2">Your Referral Code</h6>
        <div className="d-flex align-items-center gap-2 flex-wrap">
          <code style={{ fontSize: 18 }}>{referralCode}</code>
          <Button size="sm" variant="outline-secondary" onClick={copyCode}>{copied ? "Copied!" : "Copy"}</Button>
        </div>
        <small className="text-muted d-block mt-2">Share this code with other businesses. When they register with it, it shows up below.</small>
      </div>

      <div className="partner-card">
        <h6 className="mb-3">Referred Businesses</h6>
        {referrals.length === 0 ? (
          <p className="text-muted mb-0">No referrals yet.</p>
        ) : (
          <div className="d-flex flex-column gap-3">
            {referrals.map((r) => (
              <div key={r._id} className="d-flex justify-content-between align-items-center flex-wrap gap-2">
                <div>
                  <div>{r.referredPartnerId?.businessName || r.referredEmail}</div>
                  <small className="text-muted">{r.referredEmail}</small>
                </div>
                <Badge bg={r.status === "Rewarded" ? "success" : "secondary"}>{r.status}</Badge>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
